const {jQuery: $} = window;

import Utils from "./utils.class";

export default class FancyAccordion {

    #theme;

    /**
     * @param {Theme} theme
     */
    constructor(theme) {
        this.#theme = theme;

        Utils.log("Registered: Fancy Accordion Component");
    }

    events() {
        const me = this;

        $('.fancy_accordion').on('click', function () {
            const $this = $(this);
            const $parent = $this.parents('.fancy_accordions');
            const num = $this.attr('data-id');
            const $desc = $parent.find('.fancy_accordion__inner[data-id="'+num+'"]');

            Utils.log("Toggling description:", num);

            if(!$this.is(".js-open")) {
                $parent.find('.fancy_accordion__inner, .fancy_accordion').removeClass('js-open');

                $this.addClass('js-open');
                $desc.addClass('js-open').hide().slideDown({
                    duration: 350
                });
            } else {
                $parent.find('.fancy_accordion__inner, .fancy_accordion').removeClass('js-open');
            }
        });

    }

}
